/*
 * Copyright (c) 2018-2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { default as classNames } from "classnames";
import { LoginPageLocators } from "../components/LoginPage/LoginPageLocators";
import { RegisterPageLocators } from "../components/RegisterPage/RegisterPageLocators";
import { ForgotPasswordPageLocators } from "../components/ForgotPasswordPage/ForgotPasswordPageLocators";
import { CommonLocators } from "../components/common/CommonLocators";
import { PasswordStrengthPageLocator } from "../components/common/PasswordStrength/PasswordStrengthPageLocator";

const qaIds = {
  ...LoginPageLocators,
  ...RegisterPageLocators,
  ...ForgotPasswordPageLocators,
  ...CommonLocators,
  ...PasswordStrengthPageLocator,
};

function ensureExistence() {
  Object.values(qaIds).reduce((acc, qaId) => {
    if (qaId in acc) {
      throw new Error(`Can not have "${qaId}" more than once`);
    }
    acc[qaId] = qaId;
    return acc;
  }, {});
}

ensureExistence();

export function qa(qaId: string) {
  if (process.env.JUSTICE_LOGINWEB_DISABLE_DATAQA === "true") {
    return null;
  }
  if (!Object.keys(qaIds).includes(qaId)) {
    const errorMessage = `QA label "${qaId}" does not exist`;
    console.error(errorMessage);
    return null;
  }
  return qaId;
}

export function qaProps(...qaValue: any[]) {
  if (process.env.JUSTICE_LOGINWEB_DISABLE_DATAQA === "true") {
    return null;
  }
  return classNames(...qaValue);
}
